export default __webpack_public_path__ + "static/media/aboutus.af0a29b8.png";